import React from 'react';
import {useTracking} from 'react-tracking';
import {Anchor, Dialogue, Heading, Text} from '@albert-io/atomic';

import withTracking from 'lib/hocs/withTracking';

import './get-started-with-albert.scss';

const TrackedLink = withTracking(Anchor, {
  onClick: {
    event: 'click',
    type: 'hyperlink',
    content: (e, props) => props.children
  }
});

interface HelpSectionProps {
  title: string;
  items: {label: string; href: string}[];
}

const helpItems = [
  {
    title: 'Getting started',
    items: [
      {
        label: 'Set up your classrooms',
        href: 'https://help.albert.io/en/articles/1884980-teacher-onboarding-getting-started'
      }
    ]
  },
  {
    title: 'Finding content',
    items: [
      {
        label: 'Discover questions to assign',
        href: 'https://help.albert.io/en/articles/1885026-how-do-i-search-for-questions-on-albert'
      }
    ]
  },
  {
    title: 'Assigning work',
    items: [
      {
        label: 'Assign students practice',
        href: 'https://help.albert.io/en/articles/4942861-how-can-i-assign-practice-on-albert'
      }
    ]
  },
  {
    title: 'Results & data',
    items: [
      {
        label: 'View class and student data',
        href: 'https://help.albert.io/en/articles/2682890-how-can-i-view-my-classroom-and-student-data'
      }
    ]
  }
] as HelpSectionProps[];

const HelpSection = ({title, items}: HelpSectionProps) => (
  <div className='u-mar-t_3'>
    <Heading size='xxs' className='u-mar-b_1 u-text-transform_uppercase u-display_block'>
      {title}
    </Heading>
    {items.map((item) => (
      <TrackedLink as='a' href={item.href} target='_blank' rel='noopener noreferrer'>
        {item.label}
      </TrackedLink>
    ))}
  </div>
);

const GetStartedWithAlbert = () => {
  const {Track} = useTracking({
    component: 'get started with albert'
  });

  return (
    <Track>
      <Dialogue
        className='get-started-with-albert u-mar-t_4 u-width_inherit u-max-width_448 u-mar-lr_auto'
        paddingLevel={4}
        hideCloseBtn
      >
        <Heading size='s'>Getting started with Albert</Heading>
        <Dialogue.Body className='u-mar-t_3'>
          <div className='teacher-classes__class-cards-get-started-container__get-started-links u-mar-t_3'>
            {helpItems.map((item) => (
              <HelpSection {...item} />
            ))}
          </div>

          <div className='u-mar-t_6'>
            <Text size='s'>
              Not finding what you need? Search our{' '}
              <TrackedLink
                as='a'
                href='https://help.albert.io/en/collections/521216-teachers'
                target='_blank'
                rel='noopener noreferrer'
              >
                Help Center
              </TrackedLink>{' '}
              to learn more.
            </Text>
          </div>
        </Dialogue.Body>
      </Dialogue>
    </Track>
  );
};

export default GetStartedWithAlbert;
